export const sumPayments = (payments: IPartialPaymentInfo[]) =>
  payments?.reduce((sum, payment) => {
    return (sum += +payment.amount);
  }, 0);
